import { reactive } from 'vue'

class Toaster {
    // Items.
    items = reactive([])

    // Types.
    types = [
        { type: 'success', icon: 'check', iconBgColor: '#ECFDF3', iconColor: '#039855', message: 'Success message' },
        { type: 'error', icon: 'xClose', iconBgColor: '#FEF3F2', iconColor: '#D92D20', message: 'Error message' },
        { type: 'warning', icon: 'alertTriangle', iconBgColor: '#FFFAEB', iconColor: '#DC6803', message: 'Warning message' },
        { type: 'info', icon: 'infoCircle', iconBgColor: '#F9F5FF', iconColor: '#7F56D9', message: 'Info message' }
    ]

    // Generate id.
    GenerateId = () => {
        return Math.random().toString(36).substr(2, 9)
    }

    fire = (message = '', type = 'success', timer = null) => {
        type = this.types.find((d) => d.type === type)

        // Push to items.
        const item = {
            id: this.GenerateId(),
            type: type.type,
            icon: type.icon,
            iconBgColor: type.iconBgColor,
            iconColor: type.iconColor,
            message: message || type.message
        }

        this.items.push(item)

        if (timer) {
            this.items[this.items.length - 1].counter = setTimeout(() => {
                this.close(item.id)
            }, timer)
        }

        return this
    }

    close = (id) => {
        const itemIndex = this.items.findIndex((d) => d.id === id)
        const item = this.items[itemIndex]
        if (item.counter) clearTimeout(item.counter)
        return this.items.splice(itemIndex, 1)
    }

    clear = () => {
        this.items = reactive([])
    }

    success = (message = '', timer = 3000) => {
        return this.fire(message, 'success', timer)
    }

    error = (message = '', timer = 3000) => {
        return this.fire(message, 'error', timer)
    }

    warning = (message = '', timer = 3000) => {
        return this.fire(message, 'warning', timer)
    }

    info = (message = '', timer = 3000) => {
        return this.fire(message, 'info', timer)
    }
}

const Toast = new Toaster()

export default Toast